// extracted by mini-css-extract-plugin
export default {"chartWrapper":"styles_chartWrapper__BS7pk","chart":"styles_chart__fOnC4"};